import { Editor, Element, Node, Range, Transforms } from 'slate';
import { type EventHandlerParams } from './types';
import NodeUtils from '../../../AhaEditorUtils/NodeUtils';

const handleDelete = ({
  editor,
  event,
  currentBlock,
  isVoid,
}: EventHandlerParams) => {
  if (!editor.selection || !Range.isCollapsed(editor.selection)) return false;

  // If the selection is collapsed, the current block is empty, and
  // the next block is a void block, remove the current
  // block. Otherwise, do the default.
  const nextBlock = NodeUtils.nextSibling(editor, currentBlock[1], {
    match: (n) => Element.isElement(n) && Editor.isBlock(editor, n),
  });
  if (!nextBlock || !Element.isElement(nextBlock[0])) return false;

  if (!Editor.isVoid(editor, nextBlock[0])) return false;

  if (Node.string(currentBlock[0]) === '') {
    event.preventDefault();
    Transforms.removeNodes(editor, { at: currentBlock[1] });
    return true;
  }

  return false;
};

export default handleDelete;
